import {ClickTracker} from '@aoflmkt/tracker-queue';
import {uuid} from '@aofl/uuid';
import clickTrackerConfig from './__config/click-tracker';
import {eventNames} from './constants-enumerate';
import {marketingTrackerQueue} from './marketing-tracker-queue';

const clickTrackerMixin = (superClass) => {
  /**
   * @summary ClickTrackerMixin
   * @extends {superClass}
   */
  class ClickTrackerMixin extends superClass {
    /**
     * constructor
     */
    constructor(...args) {
      super(...args);
      this.trackerId = uuid();
    }
    /**
     *
     * @memberof ClickTrackerMixin
     */
    connectedCallback(...args) {
      super.connectedCallback(...args);

      marketingTrackerQueue
        .track(this.trackerId, new ClickTracker(clickTrackerConfig, (e, domScope) => {
          if (domScope) {
            marketingTrackerQueue.enqueueEvent({
              event_type: eventNames.LINK_CLICK,
              payload: {
                id: domScope
              }
            });
          }
        }, this.shadowRoot));
    }
    /**
     *
     * @param {any} args
     * @memberof ClickTrackerMixin
     */
    disconnectedCallback(...args) {
      marketingTrackerQueue.untrack(this.trackerId);

      super.disconnectedCallback(...args);
    }
  }

  return ClickTrackerMixin;
};

export {
  clickTrackerMixin
};
